import { defineComponent as n, createBlock as t, openBlock as p, createSlots as s, renderList as i, withCtx as a, renderSlot as c, normalizeProps as m, guardReactiveProps as u } from "vue";
import l from "./InputNumber-CJ1ZLzd0.js";
const $ = /* @__PURE__ */ n({
  __name: "InputNumberFloat",
  props: {
    precision: [Number, String]
  },
  setup(_) {
    return (r, f) => (p(), t(l, {
      precision: r.$props.precision ?? 2
    }, s({ _: 2 }, [
      i(r.$slots, (d, e) => ({
        name: e,
        fn: a((o) => [
          c(r.$slots, e, m(u(o ?? {})))
        ])
      }))
    ]), 1032, ["precision"]));
  }
});
export {
  $ as default
};
//# sourceMappingURL=InputNumberFloat-CjOBLBJt.js.map
